import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from 'store/configureStore';

import Sentry from 'services/Sentry/SentryInstance';

import App from './App';
import { isProd } from './helpers/utils';
import reportWebVitals from './reportWebVitals';
import { initDatadogRum } from './services/DataDog';
import { initOneTrust } from './services/OneTrust/initOneTrust';

Sentry.init();

isProd() && initOneTrust();

initDatadogRum();

const rootDiv = document.getElementById('root');

if (rootDiv) {
    const root = createRoot(rootDiv);

    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}

reportWebVitals(() => {});
